export default __webpack_public_path__ + "static/ministerstwo_cyfryzacji-d55edbd6d5fcee5e9d5c448275744e29.png";